
import IFeature from "../IFeature.ts";
import VideoRecorderController from "./VideoRecorderController.ts";
import { VideoRecorderUI } from "./VideoRecorderUI.tsx";

class VideoRecorder implements IFeature {
  public ui = VideoRecorderUI;
  public controller = VideoRecorderController;
  public dependencies: IFeature[] = [];
}

export default VideoRecorder;